export default [
    //The corresponding pdfs are missing.
    { id: 'carouselair1', title: 'Ozono', src: 'ozono.png', src_hover: 'ozono_h.png', pdf: '' },
    { id: 'carouselair2', title: 'Material Particulado', src: 'm_particulado.png', src_hover: 'm_particulado_h.png', pdf: '' },
    { id: 'carouselair3', title: 'Dioxido de Azufre', src: 'd_azufre.png', src_hover: 'd_azufre_h.png', pdf: '' }
]